import { Component, EventEmitter, Output, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

@Component({
  selector: 'app-continue-cancel',
  standalone: true,
  imports: [],
  templateUrl: './continue-cancel.component.html',
  styleUrls: ['./continue-cancel.component.scss'],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ContinueCancelComponent implements OnInit {

  @Output() cancelEmitter = new EventEmitter();
  @Output() backEmitter = new EventEmitter();
  @Input() primaryName: string;
  @Input() spinner: boolean;
  @Input() showBackButton: boolean = false; // If true, show "Back" instead of "Cancel"

  public primaryButtonName: string;
  public divWidth: string = 'col-xl-2';
  public offsetWidth: string = 'col-xl-8';
  public leftPaddingString: string = 'leftPadding';

  constructor(private router: Router) { }

  ngOnInit(): void {

      if(this.primaryName == undefined){
        this.primaryButtonName = 'Next';
      }else {
        this.primaryButtonName = this.primaryName;
      }

      if(this.router.url == '/authorization' || this.router.url == '/consent'){
        this.divWidth = 'col-xl-3';
        this.offsetWidth = 'col-xl-6';
      } else {
        this.divWidth = 'col-xl-2';
        this.offsetWidth = 'col-xl-8';
      }

      if(this.router.url == '/esign-disclosure'){
        this.leftPaddingString = 'leftPadding';
      } else {
        this.leftPaddingString = '';
      }

      this.spinner = false;
  }

  public onCancel(){
    this.cancelEmitter.emit(true);
  }

  public onBack(){
    this.backEmitter.emit(true);
  }
}
